import page from 'page';

const navigate = {
  to: (url) => {
    page(url);
  },

  replace: (url) => {
    page.replace(url);
  },

  reload: () => {
    window.location.reload();
  },

  shutdown: () => {
    page.stop();
  }
};

export default navigate;
